import { LoadingButton } from "@mui/lab";
import { Divider, TextField } from "@mui/material";
import { Box, Button, DialogContent } from "@mui/material";
import { Dialog, DialogTitle } from "@mui/material";
import {
  DateCalendar,
  DatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useRef, useState } from "react";

const CustomDatePickerDialog = ({
  value,
  handleCustomMonthChange,
  open,
  handleDateRangePicker,
  handleSubmit,
  disableBtnLoading,
}) => {
  const currentYear = dayjs().year();
  const handleClose = () => {
    handleDateRangePicker();
  };

  return (
    <div>
      <Dialog onClose={handleClose} open={open} maxWidth="xs" fullWidth>
        <DialogTitle>Select Custom Month</DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            sx={{
              width: "100%",
              marginTop: "20px",
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar
                label="Select Month"
                views={["year", "month"]}
                openTo="month"
                value={value}
                maxDate={dayjs()}
                onChange={(newValue) => handleCustomMonthChange(newValue)}
                shouldDisableYear={(date) => {
                  const year = date.year();
                  return year < 2025 || year > currentYear; // Only enable 2025 if it's 2025, and 2025-2026 if it's 2026
                }}
                sx={{ width: "100%" }}
              />
            </LocalizationProvider>
          </Box>
        </DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
            margin: "20px 20px 20px 0px",
          }}
        >
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <LoadingButton
            variant="contained"
            onClick={handleSubmit}
            loading={disableBtnLoading}
          >
            Apply
          </LoadingButton>
        </Box>
      </Dialog>
    </div>
  );
};

export default CustomDatePickerDialog;
